module.exports = __webpack_public_path__ + "static/icons/person-0-1-2.b4b39ef.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/nps/person-0-1-2.svg
// module id = eNRD
// module chunks = 1